import React from 'react';
import { Flower2, Baby, Heart, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { services } from '../mock';

const iconMap = {
  Flower2: Flower2,
  Baby: Baby,
  Heart: Heart,
  Sparkles: Sparkles
};

export const Services = () => {
  return (
    <section id="services" className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest-green mb-4">
            Featured Services
          </h2>
          <p className="text-lg text-earth max-w-2xl mx-auto">
            Comprehensive Ayurvedic care tailored to your unique health needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="group relative overflow-hidden border-none bg-white/60 backdrop-blur-md hover:bg-white transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl"
              >
                {/* Service Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest-green/80 to-transparent"></div>
                  
                  {/* Icon */}
                  <div className="absolute bottom-4 left-4 w-12 h-12 bg-sage-green rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-6 h-6 text-white" />
                  </div>
                </div>

                <CardContent className="p-6">
                  <h3 className="text-xl font-serif font-bold text-forest-green mb-3">
                    {service.title}
                  </h3>
                  <p className="text-earth leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>

                {/* Decorative Border */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-sage-green to-forest-green transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
